export const WEB_URL_ACTIONS = {
  PENDING: 'WEB_URL_PENDING',
  REJECTED: 'WEB_URL_REJECTED',
  FULFILLED: 'WEB_URL_FULFILLED',
};



// WEBPACK FOOTER //
// ./src/constants/liveCommerceConstants/webUrl.js